<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <h1 class="title is-4 has-text-centered">Please, authorize</h1>
        <div class="columns">
          <div class="column is-4 is-offset-4">
            <div v-on:keyup.enter="login" v-on:input="clearError">
              <div class="field">
                <div class="control has-icon has-icon-right">
                  <input
                    name="username"
                    type="email"
                    placeholder="Enter your email"
                    v-model="credentials.username"
                    v-bind:class="{ 'input': true, 'is-medium': true, 'is-danger': veeErrors.has('username') }"
                    v-validate="'required'">
                  <span class="icon is-small"><i class="fa fa-envelope"></i></span>
                </div>
                <span v-show="veeErrors.has('username')" class="help is-danger">{{ veeErrors.first('username') }}</span>
              </div>

              <div class="field">
                <div class="control has-icon has-icon-right">
                  <input
                    name="password"
                    placeholder="Enter your password"
                    type="password"
                    v-model="credentials.password"
                    v-bind:class="{ 'input': true, 'is-medium': true, 'is-danger': veeErrors.has('password') }"
                    v-validate="'required'">
                  <span class="icon is-small"><i class="fa fa-lock"></i></span>
                </div>
                <span v-show="veeErrors.has('password')" class="help is-danger">{{ veeErrors.first('password') }}</span>
              </div>

              <div class="field">
                <div class="control">
                  <span class="help is-danger" v-if="error">{{ error }}</span>
                </div>
              </div>

              <div class="field is-grouped is-grouped-centered">
                <div class="control">
                  <button class="button is-dark" v-on:click="login">Login</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-foot">
      <div class="container has-text-centered has-text-grey">
        <p class="is-size-7">Fusion Console by <a href="https://fusionnextinc.com/">Fusion Next Inc.</a></p>
        <p class="is-size-7">{{ year }} &copy;</p>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        credentials: {
          grant_type: 'password',
          client_id: '4aDuV38A7602sgCETc53uYX5SiVYRz8g',
          username: '',
          password: '',
          user_type: 'admin'
        },
        error: '',
        year: new Date().getFullYear()
      }
    },

    methods: {
      login (event) {
        if (event) event.preventDefault()

        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.$store.dispatch('login', this.credentials)
            .then(() => {
              this.$store.dispatch('setToken', this.$store.state.accessToken)

              window.localStorage.setItem(`${process.env.LOCALSTORAGE_PREFIX}access_token`, this.$store.state.accessToken)
              window.localStorage.setItem(`${process.env.LOCALSTORAGE_PREFIX}refresh_token`, this.$store.state.refreshToken)
              window.localStorage.setItem(`${process.env.LOCALSTORAGE_PREFIX}expires_in`, this.$store.state.expiresIn)
              window.localStorage.setItem(`${process.env.LOCALSTORAGE_PREFIX}admin_id`, this.$store.state.adminId)

              // Count time token will expire in
              window.localStorage.setItem(`${process.env.LOCALSTORAGE_PREFIX}token_expiration_time`, Math.round(Date.now() / 1000) + parseInt(this.$store.state.expiresIn))
            })
            .then(() => {
              // Show console
              this.$store.commit('SET_AUTHENTICATED', true)
            })
            .catch(() => {
              if (this.$store.state.error.response) {
                this.error = this.$store.state.error.response.data.error_description
                return
              }

              this.error = this.$store.state.error.message
              return
            })
        })
      },

      clearError () {
        // Clear error object in store
        this.$store.commit('CLEAR_ERROR')
        this.error = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?4ee9924a